export default "__VITE_ASSET__2996a007__"